import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type AccordionProps = {
  title: string;
  lines: string[];
  tone?: 'module' | 'bonus';
  previewImage?: string;
  previewAlt?: string;
};
export function Accordion({
  title,
  lines,
  tone = 'module',
  previewImage,
  previewAlt = ''
}: AccordionProps) {
  const [open, setOpen] = useState(false);
  const contentId = useId();
  const isModule = tone === 'module';
  return <article className={`overflow-hidden rounded-2xl border ${tone === 'bonus' ? 'border-[#c77f60]/30 bg-[#fffaf1]' : 'border-[#5b7255]/25 bg-white/80'}`} data-id="element-1">
      {previewImage && <div className="relative h-36 overflow-hidden sm:h-44" data-id="element-2">
          <img src={previewImage} alt={previewAlt} className="h-full w-full object-cover transition-transform duration-500" data-id="element-3" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#263a2a]/80 via-[#263a2a]/20 to-transparent" aria-hidden="true" data-id="element-4" />
          <p className="absolute bottom-3 left-4 rounded-full border border-white/25 bg-[#263a2a]/60 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-white backdrop-blur-sm" data-id="element-5">
            Vista previa
          </p>
        </div>}
      <h3 data-id="element-6">
        <button type="button" className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-semibold text-[#263a2a] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#b85f42] focus-visible:ring-inset" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={contentId} data-id="element-7">
          <span className="text-sm leading-5" data-id="element-8">{title}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-9" />
        </button>
      </h3>
      <div id={contentId} hidden={!open} className={`border-t px-5 py-4 ${isModule ? 'border-[#5b7255]/15' : 'border-[#c77f60]/15'}`} data-id="element-10">
        <ul className="space-y-2 text-sm leading-5 text-[#4c594c]" data-id="element-11">
          {lines.map(line => <li key={line} className="flex gap-2" data-id="element-12">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#b85f42]" aria-hidden="true" data-id="element-13" />
              <span data-id="element-14">{line}</span>
            </li>)}
        </ul>
      </div>
    </article>;
}